import i18n from '@/locales'

export const BILL_TYPES = [
  { key: 'month', value: i18n.t('bill.bill_type_month') },
]

export const PERIOD_TYPES = [
  { key: 'day', value: i18n.t('bill.period_type_day') },
  { key: 'week', value: i18n.t('bill.period_type_week') },
  { key: 'month', value: i18n.t('bill.period_type_month') },
]

export const GROUP_TABS = [
  {
    label: i18n.t('bill.text_81'),
    key: 'platform',
    title: i18n.t('bill.text_67'),
    queryType: 'platform_brand_expense',
    trendGroup: 'brand',
  },
  {
    label: i18n.t('bill.text_73'),
    key: 'resource-type',
    title: i18n.t('bill.text_74'),
    queryType: 'res_type_stat',
    trendGroup: 'resource_type',
  },
  {
    label: i18n.t('bill.cloud_res_type'),
    key: 'origin-res-type',
    title: i18n.t('bill.cloud_resource_type_bill_percent'),
    queryType: 'origin_res_type_stat',
    trendGroup: 'origin_res_type',
  },
  // {
  //   label: i18n.t('bill.text_82'),
  //   key: 'resource',
  //   title: i18n.t('bill.text_71', ['']),
  //   queryType: 'res_top10',
  //   trendGroup: 'res_top10',
  // },
  {
    label: i18n.t('dictionary.cloudaccount'),
    key: 'account',
    title: i18n.t('bill.text_61', ['']),
    queryType: 'account_expense',
    trendGroup: 'account',
  },
  {
    label: i18n.t('dictionary.cloudprovider'),
    key: 'cloudprovider',
    title: i18n.t('bill.text_65', ['']),
    queryType: 'cloudprovider_expense',
    trendGroup: 'cloudprovider_name',
  },
  {
    label: i18n.t('bill.text_83'),
    key: 'region',
    title: i18n.t('bill.text_70'),
    queryType: 'region_expense',
    trendGroup: 'region',
  },
  {
    label: i18n.t('bill.text_84'),
    key: 'charge-type',
    title: i18n.t('bill.text_64'),
    queryType: 'charge_type_stat',
    trendGroup: 'charge_type',
  },
  {
    label: i18n.t('bill.title.project_type'),
    key: 'project-type',
    title: i18n.t('bill.title.project_type_cost_distribution'),
    queryType: 'project_type_stat',
    trendGroup: 'project_type',
  },
  {
    l: 'dictionary.domain',
    key: 'domain',
    t: 'bill.text_66',
    queryType: 'domain_expense',
    trendGroup: 'domain',
  },
  {
    l: 'dictionary.project',
    key: 'project',
    t: 'bill.project_cost_percent',
    queryType: 'project_expense',
    trendGroup: 'project',
  },
  {
    label: i18n.t('bill.external_project'),
    key: 'external_project',
    title: i18n.t('bill.external_project_cost_distribution'),
    queryType: 'external_project_name_expense',
    trendGroup: 'external_project_name',
  },
  {
    label: i18n.t('bill.product_type'),
    key: 'product_type',
    title: i18n.t('bill.product_type'),
    queryType: 'product_type_stat',
    trendGroup: 'product_type',
  },
  {
    label: i18n.t('bill.text_79'),
    key: 'tag',
    title: i18n.t('bill.text_75'),
    queryType: 'tag_stat',
    trendGroup: 'tag',
  },
  {
    l: 'dictionary.instance_tag',
    key: 'instance_tag',
    t: 'dictionary.instance_tag',
    queryType: 'tag_stat',
    trendGroup: 'instance_tag',
  },
  {
    l: 'dictionary.project_tag',
    key: 'project_tag',
    t: 'dictionary.project_tag',
    queryType: 'tag_stat',
    trendGroup: 'project_tag',
  },
  // {
  //   label: i18n.t('bill.text_45'),
  //   key: 'dimension',
  //   title: i18n.t('bill.text_301'),
  //   queryType: 'customize_dimension',
  //   trendGroup: 'customise_dimension',
  // },
]
